import { InjectionToken, NgModule, APP_INITIALIZER } from '@angular/core';
import { IPublicClientApplication, PublicClientApplication, LogLevel } from '@azure/msal-browser';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigurationService } from './shared/services/utils/configuration.service';

const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

export const initializerFactory =
  (env: ConfigurationService, configUrl: string): any =>
  () =>
    env.init(configUrl);

export const msalInstanceFactory = (config: ConfigurationService): IPublicClientApplication =>
  new PublicClientApplication({
    auth: config.getMsalSettings('msal').auth,
    cache: config.getMsalSettings('msal').cache,
    system: {
      loggerOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });

export const msalInterceptorConfigFactory = (config: ConfigurationService): MsalInterceptorConfiguration => {
  const protectedResourceMap = new Map<string, Array<string>>(
    config.getMsalSettings('interceptor').protectedResourceMap
  );

  return {
    interactionType: config.getMsalSettings('interceptor').interactionType,
    protectedResourceMap,
  };
};

export const msalGuardConfigFactory = (config: ConfigurationService): MsalGuardConfiguration => ({
  interactionType: config.getMsalSettings('guard').interactionType,
  authRequest: config.getMsalSettings('guard').authRequest,
  loginFailedRoute: config.getMsalSettings('guard').loginFailedRoute,
});

@NgModule({
  providers: [],
  imports: [MsalModule],
})
export class MsalConfigDynamicModule {
  static forRoot(configFile: string) {
    return {
      ngModule: MsalConfigDynamicModule,
      providers: [
        ConfigurationService,
        { provide: AUTH_CONFIG_URL_TOKEN, useValue: configFile },
        {
          provide: APP_INITIALIZER,
          useFactory: initializerFactory,
          deps: [ConfigurationService, AUTH_CONFIG_URL_TOKEN],
          multi: true,
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: msalInstanceFactory,
          deps: [ConfigurationService],
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: msalGuardConfigFactory,
          deps: [ConfigurationService],
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: msalInterceptorConfigFactory,
          deps: [ConfigurationService],
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
      ],
    };
  }
}
